import { render } from "./jhi-sort-indicator.vue?vue&type=template&id=2a8bfca0&ts=true"
import script from "./jhi-sort-indicator.component.ts?vue&type=script&lang=ts"
export * from "./jhi-sort-indicator.component.ts?vue&type=script&lang=ts"

import exportComponent from "G:\\Projects\\Kml\\KmlAuth\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__